import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormCheck } from 'react-bootstrap';
import AreaN1DataService from "./services/arean1.service";
import AreaN2DataService from './services/arean2.service';
import OrganigramaDataService from "./services/organigrama.service";
import OrganigramaAreaDataService from './services/organigramaarea.service'
import { useParams, useLocation } from "react-router-dom";
import { useEffect } from 'react';
//import SublocationsList from './AreaN2List';
//import NewSublocation from './NewSublocation';
import { PageHeader } from './AuxiliaryFunctions';
import ExportSidebar from './ProSideBar';
import Sidebar from './Sidebar';
import CompetenciaAreasN1List from './CompetenciaAreasN1List';
import AgregarAreaN1 from './AgregarAreaN1';
import AgregarAreaN2 from './AgregarAreaN2';
import CompetenciaAreasN2List from './CompetenciaAreasN2List';
import MessageBox from './MessageBox';
import { logout } from './actions/auth.js';
import { useDispatch } from 'react-redux';


var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditOrganigramaAreasN2 = (props) => {

  const dispatch = useDispatch();  
  
  const deletenode = (id) => {
    OrganigramaAreaDataService.deletenode(id)
    .then((resp) => {
      window.location.reload();
    })
    .catch(e => {
      if (e.response.status == 401) {
        console.log("status 401");
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
      }
    });
  }

  let params = useParams();
  const location = useLocation();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [listOfAreasN2, setlistOflistOfAreasN2] = useState([]);
  const [arean1, setAreaN1] = useState(null);
  //const {organigrama} = location.state.organigrama || {};
  const [organigrama, setOrganigrama] = useState({});
  const [pagetitle, setpagetitle] = useState(null);

  useEffect(() => {
    retrieveAreaN1();
    retrieveOrganigramaAreasN2();     
    setOrganigrama(location.state?location.state.organigrama:{});    
  }, []);

  useEffect(() => {
    if (arean1) {
      console.log(retrieveAreaN1);
      setpagetitle("Organigrama: " + organigrama.nombreorganigrama + "; área N1: " + arean1.nombrearea);
    }
    else {
      setpagetitle("No existe el área N1 con id=" + params.childid);      
    }
  }, [arean1]);

  const retrieveAreaN1 = () => {
    AreaN1DataService.get(params.childid)
      .then(response => {
        console.log(response.data);
        setAreaN1(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }  

  const retrieveOrganigramaAreasN2 = () => {
    OrganigramaAreaDataService.getOrganigramaArea({parentid:params.idorganigramaarea, childid:0, childcategory:'arean2'},"id","ASC")
      .then(response => {
        setlistOflistOfAreasN2(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }
  
  return (
    <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />            
        <Container>
          <Row className='mb-4'>
            <PageHeader />
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>{pagetitle}</h5>      
          
            {showerror && (
              <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                <Alert.Heading>Error</Alert.Heading>
                <p>{errmessage}</p>
              </Alert>      
            )}
            {showsuccess && (
              <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                <Alert.Heading>Done</Alert.Heading>
                <p>{succmessage}</p>
            </Alert>      
            )}   
          </Row>

          <Row className='mb-4'>     
            {/**
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre organigrama:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombreorganigrama" id="nombreorganigrama" disabled defaultValue={organigrama?organigrama.nombreorganigrama:null}></FormControl>
            </Col>              
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre área N1:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombrearean1" id="nombrearean1" disabled defaultValue={arean1?arean1.nombrearea:null}></FormControl>
            </Col>             
            <Col md={10}>
              <FormLabel className='mb-2'>Descripción área N1:</FormLabel>       
              <FormControl type="text" name="descripcionarean1" id="descripcionarean1" disabled defaultValue={arean1?arean1.descripcionarea:null}></FormControl>
            </Col>   
            */}                                    

            <Col className='col-md-3' md={4}>              
              <AgregarAreaN2 arean1={arean1} parentid={params.idorganigramaarea} organigrama={organigrama}/> 
            </Col>
            
          </Row>
        
          <Row className='mb-4'>
              <Alert>{"Areas N2 habilitadas para este organigrama. Utilice el botón Config para agregar posiciones. Utilice el botón (+) para agregar más áreas N2."}</Alert>
              <CompetenciaAreasN2List
                mode={0} 
                listOfAreasN2={listOfAreasN2}
                organigrama={organigrama}
                delete={deletenode}                
              >
              </CompetenciaAreasN2List>            
          </Row>                                     
        </Container>    
      </div>
    </>
  )

}

export default EditOrganigramaAreasN2;

